import React from 'react';
import { ShieldCheckIcon, StarIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
export function GuaranteeSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#f0eaf7] py-20 px-4" data-id="element-90">
      <div className="container mx-auto max-w-3xl" data-id="element-91">
        <div ref={ref1} className={`reveal relative bg-gradient-to-br from-green-50 to-emerald-50/50 rounded-3xl p-8 md:p-14 border border-green-100 shadow-lg text-center overflow-hidden ${vis1 ? 'is-visible' : ''}`} data-id="element-92">
          <div className="absolute top-0 left-0 w-20 h-20 border-t-4 border-l-4 border-green-200 rounded-tl-3xl opacity-50" data-id="element-93"></div>
          <div className="absolute bottom-0 right-0 w-20 h-20 border-b-4 border-r-4 border-green-200 rounded-br-3xl opacity-50" data-id="element-94"></div>

          <div className="relative z-10" data-id="element-95">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full shadow-md mb-8 border-4 border-green-100" data-id="element-96">
              <ShieldCheckIcon className="w-10 h-10 text-green-600" data-id="element-97" />
            </div>

            <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 mb-6" data-id="element-98">
              🔒 Garantía de Satisfacción Total
            </h2>

            <div className="flex justify-center gap-1 mb-6" data-id="element-99">
              {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-100" />)}
            </div>

            <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-xl mx-auto mb-8" data-id="element-101">
              Probalo durante{' '}
              <span className="font-bold text-green-700" data-id="element-102">7 días</span>. Si no
              sentís claridad y avance real en tu práctica, te devolvemos el{' '}
              <span className="font-bold text-gray-900" data-id="element-103">100% del dinero</span>.
            </p>

            <div className="inline-block px-6 py-2 bg-green-100 rounded-full text-green-800 font-bold text-sm tracking-wide uppercase" data-id="element-104">
              Sin preguntas • Sin riesgos
            </div>
          </div>
        </div>
      </div>
    </section>;
}